import omitBy from 'lodash/omitBy';
import { FILTER_PREFIX } from '../../constants/FacetConstants';

export default function removeFiltersFromQuery(query) {
  return omitBy(query, (value, key) => key.indexOf(FILTER_PREFIX) === 0);
}




// WEBPACK FOOTER //
// ./app/helpers/facets/removeFiltersFromQuery.js